import React from 'react';
import { primaryVolumes, secondaryVolumes, Volume } from '../data/content';
type VolumeGroupProps = {
  title: string;
  subtitle: string;
  volumes: Volume[];
};
function VolumeGroup({
  title,
  subtitle,
  volumes
}: VolumeGroupProps) {
  return <div data-id="element-173" data-mp="kvzprkxqx3gh">
      <div className="flex items-baseline gap-3" data-id="element-174" data-mp="kyc2njoncnmo">
        <h3 className="font-display text-xl font-black tracking-tight text-navy" data-id="element-175" data-mp="pujbplccaf8u">
          {title}
        </h3>
        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-teal" data-id="element-176" data-mp="b5muoysb1rw3">
          {subtitle}
        </span>
      </div>
      <ul className="mt-5 space-y-3" data-id="element-177" data-mp="fz9b921lafx6">
        {volumes.map(volume => <li key={volume.grade} className="rounded-2xl bg-cream px-5 py-4" data-id="element-178" data-mp="27b6t4itp87c">
            <span className="inline-block rounded-full bg-navy px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-white" data-id="element-179" data-mp="752xjv7qeo9y">
              {volume.grade}
            </span>
            <h4 className="mt-2.5 font-display text-base font-bold text-navy" data-id="element-180" data-mp="3tbjdy5jk7voo">
              {volume.title}
            </h4>
            <p className="mt-1 text-xs leading-relaxed text-navy/55" data-id="element-181" data-mp="3cw0jy86rjkke">
              {volume.text}
            </p>
          </li>)}
      </ul>
    </div>;
}
export function WhatsInside() {
  return <section id="contenuto" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-182" data-mp="3ls9jdmuqqj6j">
      <div className="mx-auto max-w-4xl" data-id="element-183" data-mp="3htsaaxrreymh">
        <div className="text-center" data-id="element-184" data-mp="2u36cs0fdswqq">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-185" data-mp="2u47om7481n9i">
            8 volumi digitali · PDF ad alta risoluzione
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-186" data-mp="32w9p25eaj3js">
            <span aria-hidden="true" data-id="element-187" data-mp="2y484zxavs8j7">🖌️ </span>Cosa trovi dentro il pack{' '}
            <span className="italic text-grape" data-id="element-188" data-mp="2aexf5av2jyju">Arte Pronta?</span>
          </h2>
        </div>

        <div className="mt-12 grid gap-10 md:grid-cols-2" data-id="element-189" data-mp="26edi07ahwuxp">
          <VolumeGroup title="Percorso Scuola Primaria" subtitle="5 volumi" volumes={primaryVolumes} data-id="element-190" data-mp="26br8i241o5cu" />
          <VolumeGroup title="Percorso Scuola Media" subtitle="3 volumi" volumes={secondaryVolumes} data-id="element-191" data-mp="ebittwjsmqyu" />
        </div>
      </div>
    </section>;
}